import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminScbStats = lazy(() => import("@/pages/admin/AdminScbStats"));

export const Route = createFileRoute("/admin/statistik/scb")({
  component: () => <AdminScbStats />,
});
